import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import { WizardPageTemplate } from './WizardPageTemplate';
import type { WizardPageProps } from './configWizard.types';

type Props = Pick<WizardPageProps, 'wizardStepper'>;

export const WizardPageLoading = (props: Props) => (
  <WizardPageTemplate canNavigate={false} wizardStepper={props.wizardStepper}>
    <LoaderAndText />
  </WizardPageTemplate>
);
